<template>
  <el-container direction="vertical">
    
    <!-- 查询条件 -->
    <el-row style="height: 80px; line-height: 35px; border-radius: 4px; border: 1px solid #ccc; margin: 10px;" :gutter="10">
      <el-col :span="3">
        <el-input v-model="search.userName" placeholder="请输入姓名" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.cardNumber" placeholder="请输入身份证号" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.school" placeholder="请输入学校名称" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col v-if="!isBj" :span="4">
        <el-select v-model="search.province" multiple placeholder="请选择省份" size="mini" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="请选择"></el-option>
          <el-option v-for="(item, index) in globalData.provinceOptions" :key="index" :value="item.value" :label="item.text"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.examPoint" placeholder="请选择考点" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="请选择"></el-option>
          <el-option value="天津" label="天津"></el-option>
          <el-option value="江苏" label="江苏"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.status" multiple placeholder="奖项" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="全部"></el-option>
          <el-option value="1" label="省一"></el-option>
          <el-option value="2" label="省二"></el-option>
          <el-option value="3" label="省三"></el-option>
          <el-option value="4" label="未获奖"></el-option>
        </el-select>
      </el-col>

      <el-col :span="3">
        <el-select v-model="search.join" placeholder="是否报名" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="0" label="未报名"></el-option>
          <el-option value="1" label="已报名"></el-option>
        </el-select>
      </el-col>
   
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
        <json-excel v-if="hasRole" :data="exportData" name='科普初赛获奖名单.xls' :beforeGenerate="beforeExport" type='xls' :fields='exportFields' style='display:inline-block;margin:0 10px'>
          <el-button type="warning" icon="el-icon-download">导出</el-button>
        </json-excel>
      </el-col>
    </el-row>

    <!-- 数据展示 -->
    <el-row style="flex: 1; background: #ccc; margin: 0 10px;">
      <el-table :data="page.list" height="100%" border style="width: 100%" v-loading="loading">
        <!-- <el-table-column fixed="left" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="modifyStudent(scope.row)" >编辑</el-button>
            <el-button type="text" size="small" @click="deleteStudent(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column prop="userName" label="姓名" width="75"></el-table-column>
        <el-table-column prop="cardNumber" label="身份证号" width="170"></el-table-column>
        <el-table-column prop="province" label="省份" width="120"></el-table-column>
        <el-table-column prop="school" label="学校" min-width="100"></el-table-column>
        <el-table-column prop="grade" label="年级" width="70"></el-table-column>
        <el-table-column prop="awardName" label="奖项" width="90" align="center"></el-table-column>
        <el-table-column prop="awardCode" label="证书编号" width="130" align="center"></el-table-column>
        <el-table-column label="决赛报名" width="90" align="center">
          <template slot-scope="sc">
            <span v-if="sc.row.invitationCode">
              已报名
            </span>
            <span v-else>
              未报名
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="invitationCode" label="考点" width="130" align="center"></el-table-column>
        <el-table-column prop="enrollTime" label="报名时间" width="130" align="center"></el-table-column>
      </el-table>
    </el-row>
    
    <!-- 分页 -->
    <el-row style="border: 1px solid #aaa; box-sizing: border-box; background: #e1e1e1; margin: 0 10px 10px 10px; text-align: center;">
      <el-pagination background layout="prev, pager, next,total" :current-page="search.pageNum" :page-size="20" :total="page.total" @current-change="pageChange"></el-pagination>
    </el-row>

  </el-container>  
</template>

<script>
export default {
  computed: {
    hasRole() {
      let manager = this.globalData.manager
      let roles = this.globalData.exportRole
      return roles.includes(manager.id)
    },
    isBj(){
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      let roles = this.globalData.bj
      return roles.includes(manager.id)
    }
  },
  data() {
    return {
      page: {},
      search: {
        pageNum: 1,
        status:[]

      },
      loading: true,
      exportData:[],
      exportFields: {
        'ID':'id',
        '姓名':'userName',
        '性别':'gender',
        '手机号':'mobile',
        '身份证号':'cardNumber',
        '省份':'province',
        '学校':'school',
        '年级':'grade',
        '奖项':'awardName',
        '证书编号':'awardCode',
        '考点':'invitationCode',
        '报名时间':'enrollTime'
      },

    }
  },
  methods: {


    // 分页显示数据
    pageChange(n) {
      this.loadData(n)
    },

    // 数据查询
    query() {
      this.search.pageNum = 1
      this.api.works.findAwardList(this.search).then(res => {
        this.page = res.data
      })
    },

    // 导出数据
    async beforeExport() {
      this.search.pageNum = -1
      await this.api.works.findAwardList(this.search).then(res => {
        this.exportData = res.data.list
      })
    },

    isBjRole(){
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      let roles = this.globalData.bj
      return roles.includes(manager.id)
    },

    // 加载数据
    loadData(n) {
      if(this.isBjRole()) {
       this.search.province = ['北京市']
      }

      if(Object.keys(this.search).length > 0) {
        this.search.pageNum = n
        this.api.works.findAwardList(this.search).then(res => {
          this.page = res.data
          this.loading = false
        })
      }else {
        this.api.student.findPersonPage(`pageNum=${n}`).then(res => {
          this.page = res.data
          this.loading = false
        })
      }      
    }
  },
  mounted() {
    this.loadData(1)
  }
}
</script>


